import { render, staticRenderFns } from "./ConsultasAlvarasVencer.vue?vue&type=template&id=73dc98f8&scoped=true&lang=pug&"
import script from "./ConsultasAlvarasVencer.vue?vue&type=script&lang=js&"
export * from "./ConsultasAlvarasVencer.vue?vue&type=script&lang=js&"
import style0 from "./ConsultasAlvarasVencer.vue?vue&type=style&index=0&id=73dc98f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dc98f8",
  null
  
)

export default component.exports